import { Extension } from '@tiptap/core';

import { SideMenuPlugin, type SideMenuPluginProps } from './side-menu-plugin';

export type SideMenuOptions = Omit<SideMenuPluginProps, 'editor' | 'element'> & {
	element: HTMLElement | null;
	leftFunc: () => number;
};

export const SideMenu = Extension.create<SideMenuOptions>({
	name: 'sideMenu',

	addOptions() {
		return {
			element: null,
			tippyOptions: {},
			pluginKey: 'sideMenu',
			shouldShow: null,
			leftFunc() {
				return 0;
			},
		};
	},

	addProseMirrorPlugins() {
		if (!this.options.element) {
			return [];
		}

		return [
			SideMenuPlugin({
				pluginKey: this.options.pluginKey,
				editor: this.editor,
				element: this.options.element,
				tippyOptions: this.options.tippyOptions,
				shouldShow: this.options.shouldShow,
				leftFunc: this.options.leftFunc,
			}),
		];
	},
});
